<div class="breadcrumbs">
  @for (menuItem of list(); track menuItem) {
    <ingsv-adm-icons
      class="breadcrumbs__icon"
      [icon]="'arrow'"
    [color]="'primary-light'"></ingsv-adm-icons>
    <a class="breadcrumbs__link"
      [routerLink]="menuItem.link"
      [queryParams]="menuItem.queryParamsData">
      {{menuItem.name}}
    </a>
  }
</div>
